import Vue from "vue";
import App from "./App.vue";
import store from "@/store";
import vuexStore from "@/store/$u.mixin.js";
Vue.mixin(vuexStore);
import router from "./router";
import "@/plugins/vant";
import "@/assets/styles/index.less"; // global css
import "@/assets/styles/variables.less";
import "tailwindcss/tailwind.css";

import $config from "@/config/config.js";
Vue.prototype.$config = $config;
console.log("config已初始化:", $config);
Vue.config.productionTip = false;
// import VConsole from "vconsole";
// const vConsole = new VConsole();
// 挂载一些个人方法
Vue.prototype.$xin = {};
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
